var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.selectedInsight,{tag:"component",attrs:{"insight":_vm.insight}})
}
var staticRenderFns = []

export { render, staticRenderFns }